/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../../lib/@waca/dashboard-common/dist/api/PropertiesProviderAPI',
	'../../../../lib/@waca/dashboard-common/dist/core/APIFactory'
], function(PropertiesProviderAPI, APIFactory) {

	return class FormatAction {

		constructor({ features }) {
			features.Properties.registerProvider(this.getAPI());
		}

		getPropertyList() {
			return [{
				id: 'format',
				onPropertyChange: {
					refresh: {
						data: true
					}
				}
			}];
		}

		getPropertyLayoutList() {
			return [];
		}

		reset() { }

		getAPI() {
			if (!this._api) {
				this._api = APIFactory.createAPI(this, [PropertiesProviderAPI]);
			}
			return this._api;
		}
	};
});
